const init = () => {
    $(document).on('click', '.close-plans', (e) => {
        const dataProvider = $(e.currentTarget).attr('data-for');
        const providerTable = $(
            `.provider-card-packages[data-for=${dataProvider}]`
        );

        providerTable.slideToggle(333);
        $(`.close-plans[data-for=${dataProvider}]`).toggleClass('active');
        // $(`.disclaimer-text`).fadeToggle(333);
    });
};

export { init };
